import { ConfigPODTypes } from './actionTypes';

export const getConfigPOD = (data: any) => ({
  type: ConfigPODTypes.GET_CONFIG_POD,
  payload: data,
});

export const getConfigPODSuccess = (data: any) => ({
  type: ConfigPODTypes.GET_CONFIG_POD_SUCCESS,
  payload: data,
});

export const getConfigPODFail = (error: any) => ({
  type: ConfigPODTypes.GET_CONFIG_POD_FAIL,
  payload: error,
});

export const saveConfigPOD = (data: any) => ({
  type: ConfigPODTypes.SAVE_CONFIG_POD,
  payload: data,
});

export const saveConfigPODSuccess = (data: any) => ({
  type: ConfigPODTypes.SAVE_CONFIG_POD_SUCCESS,
  payload: data,
});

export const saveConfigPODFail = (error: any) => ({
  type: ConfigPODTypes.SAVE_CONFIG_POD_FAIL,
  payload: error,
});
